/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(String)],
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: 'search-md'
    },
    maxlength: {
      type: Number,
      default: 100
    },
    regexp: {
      type: String,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    underline: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:valid'],
  data(){ 
    return {
      valid: true
    }
  },
  computed: {
    c_value(){
      return this.value
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    }
  }

}
